/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzolini200,
  GetApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzolini401,
  GetApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzolini500,
  GetApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzoliniPathParams,
  GetApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzoliniQueryResponse,
} from "../../types/individualPaymentVanzoliniController/GetApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzolini.ts";
import { excedentBilletVanzoliniViewModelSchema } from "../excedentBilletVanzoliniViewModelSchema.ts";

export const getApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzoliniPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzoliniPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzolini200Schema =
  z.array(
    z.lazy(() => excedentBilletVanzoliniViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzolini200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzolini401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzolini401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzolini500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzolini500>;

export const getApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzoliniQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzolini200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidExcedentBilletsVanzoliniQueryResponse>;
